import { Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { View, Spinner } from '@smarterservices/smarter-ui';

const SharedSession = lazy(() => import('../pages/SharedSession'));

/**
 * Routes for shared content (magic links, public session viewing)
 * These routes do not require authentication - access is validated
 * via share-specific tokens and the shares/access endpoint.
 */
const SharedRoutes = () => {
  return (
    <Suspense
      fallback={
        <View as="div" display="flex" justifyContent="center" alignItems="center" height="100vh">
          <Spinner size="large" renderTitle="Loading..." />
        </View>
      }
    >
      <Routes>
        <Route path="/session" element={<SharedSession />} />
        <Route path="*" element={<Navigate to="/public/login" replace />} />
      </Routes>
    </Suspense>
  );
};

export default SharedRoutes;
